import axios from 'axios';

/*
Change baseURL to suit your project needs.
*/
const http = axios.create({
  timeout: 30000,
});

export default http;
